import { isDevMode } from '@angular/core';
import { TranslocoConfig } from '@jsverse/transloco';

export const iruTranslocoConfig: TranslocoConfig = {
  availableLangs: ['en', 'ja'],
  defaultLang: 'en',
  fallbackLang: 'en',
  prodMode: !isDevMode(),
  missingHandler: {
    allowEmpty: true,
    useFallbackTranslation: true,
    logMissingKey: true,
  },
  scopes: {
    keepCasing: true,
  },
  reRenderOnLangChange: false,
  flatten: {
    aot: false,
  },
  failedRetries: 2,
  interpolation: ['{{', '}}'],
};
